import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {IntegrationTypeModel} from '../../../../../models/api/integrationTypesModel';
import {AppState} from '../../../../../store/appState';
import {getFlatLegacyApplications} from '../../../../../store/data/applications/legacyApplicationsSelectors';
import {getFlatIntegrations} from '../../../../../store/data/dataSelectors';
import {
  createIntegrationAsyncAction,
  updateIntegrationAsyncAction,
} from '../../../../../store/data/integrations/integrationsActions';
import {makeGetIsIntegrationTypeEnabled} from '../../../../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppsConfigureAppDialog} from './settingsAppsConfigureAppDialog';

/*
 * Props.
 */

interface SettingsAppsConfigureAppDialogContainerProps {
  integrationType: IntegrationTypeModel;
}

/*
 * Selectors.
 */

function getIntegrationType(_state: AppState, props: SettingsAppsConfigureAppDialogContainerProps) {
  return props.integrationType;
}

function getIntegrationTypeId(_state: AppState, props: SettingsAppsConfigureAppDialogContainerProps) {
  return props.integrationType.id;
}

const getIntegration = createSelector(
  [getFlatIntegrations, getIntegrationType],
  (integrations, integrationType) =>
    _(integrations)
      .filter((integration) => integration.type === integrationType.id)
      .first(),
);

const getApplication = createSelector(
  [getFlatLegacyApplications, getIntegrationType],
  (applications, integrationType) =>
    _(applications)
      .filter((application) => application.typeId === integrationType.id)
      .first(),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAppsConfigureAppDialogContainerProps>()(() => ({
  integration: getIntegration,
  application: getApplication,
  isIntegrationEnabled: makeGetIsIntegrationTypeEnabled(getIntegrationTypeId),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateIntegrationAsync: updateIntegrationAsyncAction,
  createIntegrationAsync: createIntegrationAsyncAction,
}));

export const SettingsAppsConfigureAppDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsAppsConfigureAppDialog);
